
export function initHighlightPicture(){

    //look for bannerPoint__button elements and add click event
    let buttons = document.getElementsByClassName('bannerPoint__button');
    for (let i = 0; i < buttons.length; i++) {
        let button = buttons[i];
        button.addEventListener('click', function (event) {
            let bannerPoint = button.closest('.bannerPoint');
            let bannerPointContent = button.next('.bannerPoint__content');

            if(!bannerPoint.hasClass('active')){
                hideAllBannerPoints($('.bannerPoints'));
            }

            if(bannerPoint.hasClass('active')){
                bannerPointContent.slideUp('fast',function(){
                    bannerPointContent.css('left','');
                });
                bannerPoint.removeClass('active');
                bannerPoint.nextAll('.bannerPoint').fadeIn('fast');
                bannerPoint.prevAll('.bannerPoint').fadeIn('fast');
            }else{
                setPositionOfBannerPointContent(bannerPointContent);
                bannerPointContent.slideDown('fast');
                bannerPoint.addClass('active');
                bannerPoint.nextAll('.bannerPoint').fadeOut('fast');
                bannerPoint.prevAll('.bannerPoint').fadeOut('fast');
            }
        });
    }
}

function hideAllBannerPoints(banner){
    banner.find('.bannerPoint').removeClass('active').css({
        'display':''
    });
    banner.find('.bannerPoint__content').slideUp('fast').css({
        'left':'',
        'right':'',
        'text-align':''
    });
}

function setPositionOfBannerPointContent (thisContent) {
    thisContent.show().css('visibility','hidden');
    var widthContent = thisContent.outerWidth();
    var offsetContent = thisContent.offset();
    thisContent.css({
        'left':'',
        'right':'',
        'text-align':''
    });

    if(offsetContent.left + widthContent > $(window).width()){
        var leftPositionOfContent = $(window).width() - offsetContent.left - widthContent;
        thisContent.css('left',leftPositionOfContent - 10);
    }
    if(offsetContent.left < 0) {
        var rightPositionOfContent = offsetContent.left;
        thisContent.css({
            'right':rightPositionOfContent - 10,
            'text-align':'left'
        });
    }

    thisContent.hide().css('visibility','');
}